import { GrowthBook } from "@growthbook/growthbook-react";
import config from "config/config";

const growthbook = new GrowthBook({
  apiHost: config.growthbook.apiHost,
  clientKey: config.growthbook.apiKey,
  enableDevMode: config.growthbook.isDebug,
  subscribeToChanges: true,
});

export default growthbook;
